import React, { useMemo } from 'react';
import { Card, Col, Row, Typography, Tag, Table } from 'antd';
import { ShopOutlined, TeamOutlined, ApiOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const WhiteLabelDashboard = () => {
  const kpiCards = useMemo(
    () => [
      { title: 'Partner Companies', value: 3, icon: <TeamOutlined />, color: '#2563eb' },
      { title: 'Active White Label Instances', value: 5, icon: <ShopOutlined />, color: '#16a34a' },
      { title: 'End-User Workspaces', value: 42, icon: <ApiOutlined />, color: '#9333ea' },
      { title: 'Avg. Uptime (30d)', value: '99.9%', icon: <CheckCircleOutlined />, color: '#10b981' },
    ],
    []
  );

  const partnerColumns = [
    { title: 'Company', dataIndex: 'company', key: 'company' },
    { title: 'Domain', dataIndex: 'domain', key: 'domain' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status) => <Tag color={status === 'active' ? 'green' : 'default'}>{status}</Tag>,
    },
    { title: 'Plan', dataIndex: 'plan', key: 'plan', width: 140 },
  ];

  const partnerData = [
    {
      key: '1',
      company: 'Acme Analytics Co.',
      domain: 'analytics.acme.com',
      status: 'active',
      plan: 'White Label',
    },
    {
      key: '2',
      company: 'Nimbus UX Studio',
      domain: 'insights.nimbusux.io',
      status: 'active',
      plan: 'White Label',
    },
    {
      key: '3',
      company: 'Northwind Retail Group',
      domain: 'analytics.northwind-retail.com',
      status: 'trial',
      plan: 'Trial',
    },
  ];

  return (
    <div className="wl-dashboard">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={2} style={{ margin: 0 }}>
          White Label Overview
        </Title>
        <Text type="secondary">Track companies running Asuma as their own analytics product.</Text>
      </div>

      <Row gutter={[16, 16]}>
        {kpiCards.map((c) => (
          <Col key={c.title} xs={24} sm={12} md={12} lg={6} xl={6}>
            <Card
              hoverable
              style={{ borderRadius: 14 }}
              bodyStyle={{ display: 'flex', alignItems: 'center', gap: 12 }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  background: c.color + '22',
                  color: c.color,
                  display: 'grid',
                  placeItems: 'center',
                  fontSize: 20,
                }}
              >
                {c.icon}
              </div>
              <div>
                <Text type="secondary">{c.title}</Text>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{c.value}</div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        style={{ marginTop: 16, borderRadius: 14 }}
        title="Partner Companies"
        extra={<Text type="secondary">Demo data – wire to API when backend is ready.</Text>}
      >
        <Table columns={partnerColumns} dataSource={partnerData} pagination={false} rowKey="key" size="small" />
      </Card>
    </div>
  );
};

export default WhiteLabelDashboard;
